import React, { useContext } from 'react';
import { BLUE_600_HEX } from 'shared';

import { media } from 'context';
import { Icon, Layout, Text } from 'ds';

import PlaybookContentContainer from './PlaybookContentContainer';

interface Props {}

const SearchingForAFlexibleOffice: React.FC<Props> = () => {
  const { xs } = useContext(media);

  return (
    <PlaybookContentContainer>
      <Layout justify="space-between" flexGrow={1} overflow="hidden">
        <Layout maxWidth={660}>
          <p
            style={{ fontSize: 16, fontWeight: 700, lineHeight: '20px', letterSpacing: '0.08em', color: BLUE_600_HEX }}
          >
            02 THE SEARCH
          </p>
          <Layout marginTop={20}>
            <Text size="h2" color="blue-gradient">
              Searching for a Flex Office
            </Text>
          </Layout>
        </Layout>
        {!xs && (
          <Layout
            width={224}
            height={224}
            borderColor="blue-gradient"
            borderWidth={8}
            justify="center"
            align="center"
            borderRadius="circular"
          >
            <Icon size={104} color="blue-gradient" name="calendar" />
          </Layout>
        )}
      </Layout>
    </PlaybookContentContainer>
  );
};

export default SearchingForAFlexibleOffice;
